var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"my-0 mx-1 pa-1",attrs:{"color":"error"},on:{"click":_vm.logout}},[_vm._v("ログアウト")])
}
var staticRenderFns = []

export { render, staticRenderFns }